export default __webpack_public_path__ + "static/media/image.ldi-solutions.3827b290.png";